var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31362",
    d: "M0 0h20v20H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31363",
    d: "M11.6 7.682l.716.716-7.045 7.046h-.715v-.716L11.6 7.682M14.4 3a.779.779 0 00-.544.226l-1.421 1.423 2.917 2.917 1.423-1.423a.775.775 0 000-1.1l-1.82-1.82A.764.764 0 0014.4 3zm-2.8 2.481L3 14.083V17h2.917l8.6-8.6L11.6 5.481z",
    fill: "inherit"
  })));
}

export default SvgEdit;